import PaycheckRoutingSetupWidget from '../../../../banking/components/paycheck-routing/PaycheckRoutingSetupWidget';

export default function PaycheckRoutingSetup() {
    return <PaycheckRoutingSetupWidget />;
}
